import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const ProjectCarousel = ({ images, projectTitle }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!images || images.length === 0) {
    return null;
  }

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="relative w-full" data-testid="project-carousel">
      {/* Main Image */}
      <div className="relative aspect-[16/10] overflow-hidden bg-stone-100 border border-stone-200">
        <img
          src={images[currentIndex]}
          alt={`${projectTitle} - Image ${currentIndex + 1}`}
          className="w-full h-full object-cover"
          style={{ objectFit: 'cover', objectPosition: 'center top' }}
        />

        {/* Navigation Arrows */}
        {images.length > 1 && (
          <>
            <Button
              onClick={goToPrevious}
              data-testid="carousel-prev"
              className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-stone-900 rounded-full w-12 h-12 p-0"
            >
              <ChevronLeft className="w-6 h-6" />
            </Button>
            <Button
              onClick={goToNext}
              data-testid="carousel-next"
              className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-stone-900 rounded-full w-12 h-12 p-0"
            >
              <ChevronRight className="w-6 h-6" />
            </Button>
          </>
        )}

        {/* Image Counter */}
        {images.length > 1 && (
          <div className="absolute bottom-4 right-4 bg-stone-900/80 text-white px-3 py-1 text-sm rounded">
            {currentIndex + 1} / {images.length}
          </div>
        )}
      </div>

      {/* Thumbnail Navigation */}
      {images.length > 1 && (
        <div className="mt-4 grid grid-cols-6 gap-2" data-testid="carousel-thumbnails">
          {images.map((image, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              data-testid={`thumbnail-${index}`}
              className={`aspect-video overflow-hidden border-2 transition-all ${
                index === currentIndex
                  ? 'border-emerald-900'
                  : 'border-stone-200 hover:border-stone-400'
              }`}
            >
              <img
                src={image}
                alt={`Thumbnail ${index + 1}`}
                className="w-full h-full object-cover"
              />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProjectCarousel;
